import { Check, Loader2, AlertCircle } from "lucide-react";
import { FormField } from "@/components/FormField";
import { PUBLIC_BASE_URL } from "@/lib/canonicalUrl";
import { slugify, SLUG_MAX } from "@/features/cards/slug";

const TONE = { available: "text-emerald-800", current: "text-emerald-800", taken: "text-destructive", invalid: "text-destructive", error: "text-gold", checking: "text-muted-foreground" };

function SlugStatus({ check }) {
  if (check.state === "idle") return null;
  const Icon = check.state === "checking" ? Loader2 : check.state === "available" || check.state === "current" ? Check : AlertCircle;
  return (
    <p data-testid="card-slug-status" data-state={check.state} className={`flex items-start gap-2 text-xs ${TONE[check.state]}`}>
      <Icon className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${check.state === "checking" ? "animate-spin" : ""}`} />
      {check.message}
    </p>
  );
}

export function CardLinkFields({ editor }) {
  const { draft, errors, slugCheck, setName, setSlug, identity } = editor;
  const host = PUBLIC_BASE_URL.replace(/^https?:\/\//, "");
  return (
    <div className="space-y-6">
      <FormField id="card-name" label="Card name" maxLength={150} testId="card-name-input" value={draft.name} onChange={(e) => setName(e.target.value)} error={errors.name} hint="Only you see this name." />
      <div className="space-y-2">
        <label htmlFor="card-slug" className="mw-eyebrow">Card link</label>
        <div className={`flex items-stretch overflow-hidden rounded-md border bg-card ${errors.slug ? "border-destructive" : "border-input"} focus-within:border-foreground`}>
          <span className="hidden items-center border-r border-border bg-muted px-3 font-mono text-xs text-muted-foreground sm:flex">{host}/</span>
          <input id="card-slug" data-testid="card-slug-input" value={draft.slug} maxLength={SLUG_MAX} onChange={(e) => setSlug(e.target.value)} autoCapitalize="none" autoCorrect="off" spellCheck={false} placeholder="your-name" className="h-12 min-w-0 flex-1 bg-transparent px-3 font-mono text-sm outline-none" />
        </div>
        {errors.slug && <p data-testid="card-slug-error" className="text-xs text-destructive">{errors.slug}</p>}
        <SlugStatus check={slugCheck} />
        {!draft.slug && identity.fullName && (
          <button type="button" onClick={() => setSlug(slugify(identity.fullName))} data-testid="card-slug-generate" className="mw-link min-h-[44px] text-xs">
            Use {slugify(identity.fullName)}
          </button>
        )}
        {identity.publicProfileUrl && (
          <p data-testid="card-canonical-url" className="break-all font-mono text-[11px] text-muted-foreground">{identity.publicProfileUrl}</p>
        )}
      </div>
    </div>
  );
}
